/**
 * This module is in charge of controlling inputs for locations.
 */
(function() {

  "use strict";

  var DEFAULT_CONFIG = {
    position: 'LEFT_TOP',
    chooseRouteCallback: jQuery.noop
  };

  var ID = 0;

  define('fg-arv/components/journeys',['fg-arv/utils', 'fg-arv/components/infoJourney', 'fg-arv/libs/mustache', 'fg-arv/components/time',
      'fg-arv/google-helper', 'fg-arv/templates', 'fg-arv/components/help'
    ],
    function(utils, infoJourney, Mustache, time, googleHelper, templates, help) {
      var resizeTimeout, journeyPanels = [],
        componentElement;
      var module = {
        createComponent: function(config) {
          var container = utils.getPropertyValue(config, 'container');

          if (container) {
            var id = createDomID();
            var conf = jQuery.extend({
              id: id
            }, DEFAULT_CONFIG, config);
            var template = conf.template ? conf.template : createTemplate(conf);
            var map = conf.widget.getMap();
            var COLORS = conf.colors;
            var controls = map.controls[google.maps.ControlPosition[conf.position]].getArray();
            if (jQuery.inArray(container, controls) !== -1) {
              container = controls[jQuery.inArray(container, controls)];
            } else {
              var panelControl = container;
              jQuery(map.getDiv()).append(panelControl);
              //jQuery(panelControl).addClass('map-control');
              //map.controls[google.maps.ControlPosition[conf.position]].push(panelControl);
            }


            template = Mustache.render(template, config);

            container.innerHTML = template;
            componentElement = jQuery('#' + id);


            var component;

            journeyPanels = [];

            var listRoutes = conf.routes;
            var favouritesRoutes = config.widget.apiObject.getFavouritesRoutes();

            component = {
              getElement: function() {
                return componentElement;
              },
              init: function(config) {
                component.initializeHeader(config);
                if (listRoutes) {
                  componentElement.find('.panel-heading').show();
                  component.createSingleJourneyPanels(listRoutes);
                  jQuery(container).find('.panel-body').css('padding-bottom', '0px');
                  component.closeListener();
                } else if (config.initMobile) {
                  componentElement.find('.panel-heading-routes').css('display', 'none');
                  componentElement.find('.panel-directions').css('display', 'none');
                  if (!config.widget.fromComponent.getValue().name || !config.widget.toComponent.getValue()
                    .name) {
                    config.widget.widgetElement.find('.form-components-container').css('display', 'block');
                    componentElement.find('.panel-heading').attr('mode', 'form_mode');
                    componentElement.find('.panel-heading').hide();
                  }

                }
                component.resizeListener();
              },
              initializeHeader: function(config) {
                component.initializaHeadingRoutes(config);
                component.initializeCollapse();
                component.initializeChangeDirections();

              },
              initializeChangeDirections: function() {
                var btn = componentElement.find('.panel-directions');
                btn.click(function() {
                  jQuery(config.widget.formControl).show();
                  if (btn.hasClass('close glyphicon glyphicon-arrow-left')) {
                    btn.removeClass('close glyphicon glyphicon-arrow-left');
                    componentElement.find('.panel-heading').attr('mode', 'panel_mode');

                  } else {
                    btn.addClass('close glyphicon glyphicon-arrow-left');
                    componentElement.find('.panel-heading').attr('mode', 'form_mode');
                    config.widget.widgetElement.find('.form-components-container').css('display',
                      'block');

                  }
                  component.responsivePanels();
                });
              },
              initializaHeadingRoutes: function(config) {
                var date = config.departureTime ? config.departureTime : config.arrivalTime,
                  innerhtml = "<div class='col-xs-9 ellipsis left header-font' title='" + config.departureDirection +
                  "'>" + config.departureDirection + " </div><div class='header-arrow col-xs-1'></div>" +
                  "<div class='col-xs-10 ellipsis left header-font' title='" + config.arrivalDirection +
                  "'>" + config.arrivalDirection + "</div><div class='col-xs-10 left ellipsis text-date'>" +
                  component.getTextDate(date) + "</div>";
                componentElement.find('.panel-heading-routes').html(innerhtml);

              },
              getTextDate: function(date) {
                if (!date) {
                  return;
                }
                var time = config.widget.timeComponent.getValue();
                var modeRoute = config.widget.journeyModeComponent.getValue();
                return date.getDayName(true) + " " + date.getDate() + " " + date.getMonthName(true) + ", " +
                  modeRoute + " " + time;
              },
              initializeCollapse: function() {
                componentElement.find('.panel-heading-collapse').click(function() {
                  var btn = jQuery(this);
                  if (btn.hasClass('collapsed')) {
                    if (componentElement.find('.panel-directions').hasClass('close') ||
                      (componentElement.find('.panel-directions').css('display') === 'none' && window.innerWidth <=
                        540)) {
                      componentElement.find('.panel-heading').attr('mode', 'form_mode');
                    } else {
                      componentElement.find('.panel-heading').attr('mode', 'panel_mode');
                    }
                  } else {
                    componentElement.find('.panel-heading').attr('mode', 'map_mode');
                  }
                  component.responsivePanels();
                });
              },
              getID: function() {
                return id;
              },

              createSingleJourneyPanels: function(routes) {
                var timeDepartureImpossible = 0;
                // config.widget.widgetElement.find('.form').css('display', 'none');

                function makeHidePanelCb() {
                  return function() {
                    component.deletePanel();
                  };
                }

                function makeShowPanelCb() {
                  return function() {
                    container.innerHTML = template;
                    openJourney = this.index;
                    componentElement = jQuery(container);
                    component.createSingleJourneyPanels(listRoutes);
                    componentElement.css('max-height', calculateHeight(conf, container));
                    jQuery(container).find('.close-panel').click(function() {
                      component.closePanel();
                    });
                  };
                }

                function makeCollapsePanelsCb() {
                  return function() {
                    for (var jp = 0; jp < journeyPanels.length; jp++) {
                      journeyPanels[jp].collapse();
                    }
                  };
                }

                function deselectPanels() {
                  return function() {
                    componentElement.find('.panel-route').removeClass('selected');
                  };
                }

                var deferred = new jQuery.Deferred();
                if (config.departureTime) {
                  _calculateLocalTime(config.widget, new Date(), 'departure').done(function(time) {
                    deferred.resolve(time);
                  });

                } else if (config.arrivalTime) {
                  _calculateLocalTime(config.widget, new Date(), 'arrival').done(function(time) {
                    deferred.resolve(time);
                  });
                }
                deferred.promise().done(function(date) {

                  //Validate routes
                  for (var r = 0; r < routes.length; r++) {
                    if (routes[r].legs[0].departure_time && (routes[r].legs[0].departure_time.value <
                        date)) {
                      timeDepartureImpossible++;
                    } else if (config.arrivalTime && config.arrivalTime.getTime() - routes[r].legs[0].duration
                      .value * 1000 < date) {
                      timeDepartureImpossible++;
                    }
                  }
                  if (timeDepartureImpossible === routes.length) {
                    //If no valid routes
                    conf.mapViewComponent.clearRoutes();
                    if (window.innerWidth <= 540) {
                      container.innerHTML = templates.createNoRoutesDivMobile();
                    } else {
                      container.innerHTML = templates.createNoRoutesDiv();
                    }
                    var legend = config.widget.widgetElement.find('.fg-arv_legend-component')[0];
                    if (legend) {
                      legend.hidden = true;
                    }
                    return;
                  } else {
                    setTimeout(function() {
                      var possibleRoutes = [],
                        colors = [];
                      routes = component.orderFavoriteRoutes(routes);
                      for (var r = 0; r < routes.length; r++) {
                        if (!(routes[r].legs[0].departure_time && (routes[r].legs[0].departure_time
                            .value < date)) &&
                          !(config.arrivalTime && config.arrivalTime.getTime() - routes[r].legs[0].duration
                            .value * 1000 < date)) {
                          possibleRoutes.push(routes[r]);
                        }
                      }
                      for (var rt = 0; rt < possibleRoutes.length; rt++) {
                        colors.push(rt < 9 ? COLORS[rt] : COLORS[parseInt(rt % 9)]);
                        var journeyPanel = infoJourney.createComponent({
                          container: componentElement.find('.panel-body'),
                          heading: componentElement.find('.panel-heading').html(),
                          route: possibleRoutes[rt],
                          index: rt,
                          color: rt < 9 ? COLORS[rt] : COLORS[parseInt(rt % 9)],
                          widget: config.widget,
                          mainContainer: container,
                          mapView: conf.mapViewComponent,
                          departureTime: config.departureTime,
                          arrivalTime: config.arrivalTime,
                          clickCallback: deselectPanels(),
                          isLast: rt === possibleRoutes.length - 1 ? true : false,
                          getJourneyComponent: function() {
                            return component;
                          }
                        });
                        if (rt === 0) {
                          deselectPanels();
                          //journeyPanel.clickOnRoute();
                        }
                        journeyPanels.push(journeyPanel);
                      }
                      if (possibleRoutes.length !== routes.length) {
                        config.widget.mapViewComponent.updateRoutes(possibleRoutes, colors);
                        journeyPanels[0].clickOnRoute();
                      }
                    }, 10);
                  }
                });

              },
              orderFavoriteRoutes: function(routes) {
                var newRoutes = routes;

                for (var rt = 0; rt < newRoutes.length; rt++) {
                  if (component.isFavorite(newRoutes[rt])) {
                    newRoutes[rt].favorite = true;
                    var to = 0;
                    while (routes[to].favorite) {
                      to++;
                    }
                    moveInArray(rt, to, newRoutes);

                  }
                }
                return newRoutes;
              },
              isFavorite: function(route) {
                var isFavorite = false;
                for (var r in favouritesRoutes) {
                  if (JSON.stringify(favouritesRoutes[r]).replace(/"/g, '') === JSON.stringify(component.getFavoriteRouteObject(
                      route)).replace(/"/g, '')) {
                    isFavorite = true;
                    break;
                  }
                }
                return isFavorite;

              },
              getFavoriteRouteObject: function(route) {
                var favoriteRoute = {
                  geom: route.overview_polyline,
                  legs: []
                };
                for (var l in route.legs) {
                  var leg = {};
                  leg.steps = [];
                  for (var s in route.legs[l].steps) {
                    var step = route.legs[l].steps[s];
                    leg.steps.push({
                      geom: step.encoded_lat_lngs,
                      travelMode: step.travel_mode,
                      numStops: step.transit ? step.transit.num_stops : 0
                    });
                  }
                  favoriteRoute.legs.push(leg);
                }
                return favoriteRoute;
              },
              saveFavoriteRoute: function(route) {
                var favoriteRoute = component.getFavoriteRouteObject(route);
                config.widget.apiObject.saveFavouriteRoute(JSON.stringify(favoriteRoute).replace(/"/g, ''));
                var routes = component.getRoutes();
                for (var rt = 0; rt < routes.length; rt++) {
                  if (JSON.stringify(favoriteRoute) === JSON.stringify(component.getFavoriteRouteObject(
                      routes[rt]))) {
                    var panelRoute = module.getPanelByRoute(routes[rt]);
                    panelRoute.checkAsFavorite();
                  }
                }
              },
              removeFavoriteRoute: function(route) {
                var favoriteRoute = component.getFavoriteRouteObject(route);
                config.widget.apiObject.removeFavouriteRoute(JSON.stringify(favoriteRoute).replace(/"/g, ''));
                var routes = component.getRoutes();
                for (var rt = 0; rt < routes.length; rt++) {
                  if (JSON.stringify(favoriteRoute) === JSON.stringify(component.getFavoriteRouteObject(
                      routes[rt]))) {
                    var panelRoute = module.getPanelByRoute(routes[rt]);
                    panelRoute.unCheckAsFavorite();
                  }
                }
              },
              clearSingleRoutesPanel: function() {
                componentElement.find('.panel-body')[0].innerHTML = "";

              },

              getRoutes: function() {
                return listRoutes;
              },

              deletePanel: function() {
                componentElement = conf.widget.widgetElement.find('.info-journey-panel');
                componentElement.hide();
              },
              closePanel: function() {
                component.deletePanel();
                config.widget.widgetElement.find('.form').css('display', 'block');

              },
              resetPanel: function() {
                conf.mapViewComponent.resetMapView();
                component.deletePanel();
                module.createComponent({
                  container: conf.container,
                  routes: conf.routes,
                  widget: conf.widget,
                  departureTime: conf.departureTime,
                  arrivalTime: conf.arrivalTime,
                  departureDirection: conf.departureDirection,
                  arrivalDirection: conf.arrivalDirection,
                  mapViewComponent: conf.mapViewComponent,
                  colors: conf.colors,
                  message: conf.message
                });
              },
              calculateSize: function() {
                var rootElementID = config.widget.apiObject.getDOMElementID();
                var rootElementSelector = "#" + rootElementID;
                var rootElement = jQuery(rootElementSelector);
                var formControl = rootElement.find(".form")[0];
                var journeyControl = rootElement.find(".fg-arv_info-journey-component")[0];
                var legendControl = rootElement.find(".fg-arv_legend-component")[0];
                var formHeight = formControl ? formControl.scrollHeight + 20 : 0;
                var journeyWidth = journeyControl || journeyControl.scrollWidth !== 0 ? journeyControl.scrollWidth +
                  40 : 369;
                var legendWidth = legendControl ? legendControl.scrollWidth : 103;
                var boundDim = {
                  formHeight: formHeight,
                  journeyWidth: window.innerWidth <= 540 ? 0 : journeyWidth,
                  legendWidth: legendWidth,
                  rootElementWidth: rootElement.width(),
                  rootElementHeight: rootElement.height()
                };
                for (var i in listRoutes) {
                  config.mapViewComponent.fitBounds(listRoutes[i].bounds, boundDim);
                }
                if (config.mapViewComponent) {
                  config.widget.getMap().fitBounds(config.mapViewComponent.getMaxBounds());
                  config.widget.getMap().setZoom(config.mapViewComponent.getMinZoom());
                }
                //Move map center
                if (window.innerWidth > 540) {
                  config.widget.getMap().panBy(-((boundDim.journeyWidth - boundDim.legendWidth - 40) / 2),
                    -((boundDim.formHeight - 20) / 2));
                }
                component.responsivePanels(boundDim);
                var maxHeight = calculateHeight(conf, container);
                jQuery(container).css('max-height', maxHeight + 'px');
              },
              responsivePanels: function(boundDim) {
                var mobile = config.widget.widgetElement.find('.form-components-container').closest('.form')
                  .hasClass('mobile-mode');
                var mode = componentElement.find('.panel-heading').attr('mode');
                var form = config.widget.widgetElement.find('.form-components-container').closest('.form');
                var panel = componentElement.find('.content-info-journey .panel-body');
                if (window.innerWidth <= 540) {
                  form.addClass('mobile-mode');
                  form.addClass('hasResults');
                  if (componentElement.css('display') === 'none') {
                    componentElement.show();
                  }
                  if (mode === 'map_mode') {
                    panel.addClass('hidden');
                    form.addClass('hidden');
                    componentElement.find('.panel-heading-collapse').addClass('collapsed');
                    component.closeRoutePanel();
                  } else if (mode === 'panel_mode') {
                    panel.removeClass('hidden');
                    form.addClass('hidden');
                    componentElement.find('.panel-heading-collapse').removeClass('collapsed');
                    component.openRoutePanel();
                  } else {
                    panel.addClass('hidden');
                    form.removeClass('hidden');
                    componentElement.find('.panel-heading-collapse').removeClass('collapsed');
                    component.openRoutePanel();
                  }
                } else {
                  form.removeClass('mobile-mode');
                  form.removeClass('hidden');
                  if (mode === 'map_mode') {
                    panel.addClass('hidden');
                    componentElement.find('.panel-heading-collapse').addClass('collapsed');
                    component.closeRoutePanel();
                  } else {
                    if (!config.widget.fromComponent.getValue().name || !config.widget.toComponent.getValue()
                      .name) {
                      componentElement.hide();
                      form.css('top', 0);
                    }
                    panel.removeClass('hidden');
                    componentElement.find('.panel-heading-collapse').removeClass('collapsed');
                    component.openRoutePanel();
                  }
                }
                //Calculate info-journey width
                var collapseWidth = componentElement.find('.panel-heading-collapse').width();
                var directionsWidth = componentElement.find('.panel-directions').width();
                var panelWidth = componentElement.find('.panel-heading').width();
                var routesWidth = panelWidth - collapseWidth - directionsWidth - 15;

                componentElement.find('.panel-heading-routes').css('width', routesWidth + 'px');
              },
              resizeListener: function() {
                jQuery(window).resize(function() {
                  if (resizeTimeout) {
                    clearTimeout(resizeTimeout);

                  }

                  resizeTimeout = setTimeout(function() {
                    component.responsivePanels();
                    if (config.widget.fromComponent.getValue().name && config.widget.toComponent.getValue()
                      .name) {
                      component.calculateSize();
                    }
                  }, 10);
                });
                if (!config.widget.fromComponent.getValue().name || !config.widget.toComponent.getValue().name) {
                  componentElement.find('.panel-heading').attr('mode', 'form_mode');
                } else {
                  component.calculateSize();
                }
              },
              closeListener: function() {
                jQuery(container).find('.close-panel').click(function() {
                  component.closePanel();
                });
              },
              closeRoutePanel: function() {
                ;
                jQuery('.collapse-button').removeClass('zmdi-caret-up');
                jQuery('.collapse-button').removeClass('open');
                jQuery('.collapse-button').addClass('zmdi-caret-down');
              },
              openRoutePanel: function() {
                jQuery('.collapse-button').removeClass('zmdi-caret-down');
                jQuery('.collapse-button').addClass('zmdi-caret-up');
                jQuery('.collapse-button').addClass('open');
              },
              changeUnitSystem: function(type, className) {
                var distanceInfo = componentElement.find(className);
                var value, distNumber, distUnit, distText, num, coef, unit = null;
                for (var i = 0; i < distanceInfo.length; i++) {
                  value = jQuery(distanceInfo[i]).html();
                  distNumber = value.split(" ")[0];
                  distUnit = value.split(" ")[1];
                  if (type === "metric") {
                    coef = 1.60934;
                    unit = 'km';
                    if (distUnit === 'ft') {
                      coef = 0.3048;
                      unit = 'm';
                    }
                  } else {
                    coef = 0.621371;
                    unit = 'mi';
                    if (distUnit === 'm') {
                      coef = 3.28084;
                      unit = 'ft';
                    }
                  }
                  num = distNumber * coef;
                  distText = num.toFixed(1) + " " + unit;
                  jQuery(distanceInfo[i]).html(distText);
                }
              }
            };
            component.init(config);

            return component;
          }
        },



        getPanelByRoute: function(route) {
          for (var jp in journeyPanels) {
            if (journeyPanels[jp].getRoute() === route) {
              return journeyPanels[jp];
            }
          }
        },
        focusOnRoutePanel: function(route) {
          var routePanel = this.getPanelByRoute(route);
          if (routePanel) {
            routePanel.focusOnRoute();
          }
        },
        leaveRoutePanel: function(route) {
          var routePanel = this.getPanelByRoute(route);
          if (routePanel) {
            routePanel.leaveRoute();
          }
        },
        clickOnRoutePanel: function(route) {
          componentElement.find('.panel-route').removeClass('selected');
          var routePanel = this.getPanelByRoute(route);
          if (routePanel) {
            routePanel.clickOnRoute();
          }

        },
        closeOpenRoutesNotSelected: function() {
          var routesToClose = jQuery(".expand-route").not(".selected");
          for (var i = 0; i < routesToClose.length; i++) {
            jQuery('#' + routesToClose[i].id).find('.steps-container').html('');
            jQuery('#' + routesToClose[i].id).find('.stepByStep-button.open').removeClass('zmdi-caret-up');
            jQuery('#' + routesToClose[i].id).find('.stepByStep-button.open').addClass('zmdi-caret-down');
            jQuery('#' + routesToClose[i].id).find('.stepByStep-button.open').removeClass('open');
          }
        }
      };

      return module;

      //*********************************************************

      function createTemplate(config) {
        return "<div id='" + config.id + "' class='panel panel-default info-journey-panel list-routes-panel'>" +
          "<div class='content-info-journey'>" +
          "<a class='close-panel' href='#'>x</a>" +
          "<div class='panel-heading' mode='panel_mode'>" +
          "<div class='panel-directions'>" +
          "<div class='pointer' title='New search'></div>" +
          "</div>" +
          "<div class='panel-heading-routes'>" +
          "</div>" +
          "<div class='panel-heading-collapse'>" +
          "<a title='Collapse results' href='#' class='collapse-button zmdi zmdi-caret-up open zmdi-hc-3x stepByStep-button'></a>" +
          "<div class='pointer' title='Collapse'></div>" +
          "</div>" +
          "</div>" +
          "<div class='panel-body'>" +
          "</div>" +
          "</div>" +
          "</div>";
      }

      function createDomID() {
        var i = ++ID;
        return "fg-arv-journeys-panel-" + i;
      }

      function calculateHeight(config, container) {
        if (jQuery(container).innerWidth() < 300) {
          jQuery(container).find('.panel-body').css('overflow-x', 'auto');
        } else {
          jQuery(container).find('.panel-body').css('overflow-x', 'hidden');
        }

        var map = config.widget.getMap();
        var heightWidget = config.widget.widgetElement.height();

        var heightForm = config.widget.widgetElement.find('.form').height();
        if (heightForm !== 0) {
          heightForm += 20;
        }

        var height = heightWidget - heightForm;

        if (jQuery('html').hasClass('ie8')) {
          jQuery(container).find('.info-journey-panel').css('max-height', height + 'px');
        } else {
          jQuery(container).find('.info-journey-panel').css('max-height', height - 30 + 'px');
        }
        var heightHeader = jQuery(container).find('.panel-heading').height();

        jQuery(container).find('.panel-body').css('max-height', height - heightHeader - 22 + 'px');
        if (window.innerWidth <= 540) {
          if (heightForm !== 0) {
            height = height + heightForm;
          }
          jQuery(container).find('.panel-body').css('max-height', height - heightHeader - 2 + 'px');
        }

        jQuery(container).find('.info-journey-panel').css('position', 'relative');
        jQuery(container).find('.info-journey-panel').parent().css('top', heightForm - 20);
        if (window.innerWidth <= 540) {
          jQuery(container).find('.info-journey-panel').parent().css('top', 0);
        }
        jQuery(container).find('.panel-body').css('overflow-y', 'auto');
        return height;
      }

      function moveInArray(from, to, array) {
        array.splice(to, 0, array.splice(from, 1)[0]);
      }

      function _calculateLocalTime(widget, time, depArr) {
        var origin = widget.fromComponent.getValue(),
          destination = widget.toComponent.getValue(),
          address, localTime, deferred = new jQuery.Deferred();
        address = depArr === 'departure' ? origin : destination;

        utils.getTimeOffsetByCoord(address.coordinates, time.getTime(), widget.apiObject).done(function(
          localOffset) {
          var offset = -(time.getTimezoneOffset() - localOffset);
          localTime = utils.getTimeInLocalGMT(time.getTime(), offset);
          deferred.resolve(new Date(localTime));
        });

        return deferred.promise();
      }


    });


})();

